export interface VersionedDocument<T> { version: number; data: T }

async function parsed(response: Response) {
  return response.json().catch(() => ({})) as Promise<Record<string, unknown>>
}

export async function loadDocument<T>(key: 'talent-desk' | 'report-collaboration'): Promise<VersionedDocument<T>> {
  const response = await fetch(`/api/documents/${key}`, { credentials: 'include', cache: 'no-store' })
  const result = await parsed(response)
  if (!response.ok) throw new Error(String(result.message ?? 'Não foi possível carregar os dados compartilhados.'))
  return result as unknown as VersionedDocument<T>
}

export async function saveDocument<T>(key: 'talent-desk' | 'report-collaboration', value: VersionedDocument<T>) {
  const response = await fetch(`/api/documents/${key}`, { method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(value) })
  const result = await parsed(response)
  if (!response.ok) throw new Error(String(result.message ?? 'Não foi possível salvar os dados compartilhados.'))
  return result as unknown as VersionedDocument<T>
}
